import ClipboardJS from 'clipboard'
import { showToast } from '@/utils/message'
import { shareToNative } from './useShareCapture'

function buildShareText(payload = {}) {
  return [payload.title, payload.desc, payload.link].filter(Boolean).join('\n')
}

function fallbackCopyByExecCommand(text = '') {
  const input = document.createElement('textarea')
  input.value = text
  input.setAttribute('readonly', 'readonly')
  input.style.position = 'fixed'
  input.style.opacity = '0'
  document.body.appendChild(input)
  input.select()
  let ok = false
  try {
    ok = document.execCommand('copy')
  }
  catch (error) {
    ok = false
  }
  document.body.removeChild(input)
  return ok
}

export function copyWithPlugin(text = '') {
  if (!text) return Promise.resolve(false)
  return new Promise((resolve) => {
    const trigger = document.createElement('button')
    trigger.style.display = 'none'
    trigger.setAttribute('type', 'button')
    document.body.appendChild(trigger)

    const clipboard = new ClipboardJS(trigger, { text: () => text })
    clipboard.on('success', () => {
      clipboard.destroy()
      document.body.removeChild(trigger)
      resolve(true)
    })
    clipboard.on('error', async () => {
      clipboard.destroy()
      document.body.removeChild(trigger)
      try {
        await navigator.clipboard.writeText(text)
        resolve(true)
      }
      catch (error) {
        resolve(fallbackCopyByExecCommand(text))
      }
    })
    trigger.click()
  })
}

function openFallbackUrl(url) {
  if (!url) return
  window.location.href = url
}

function buildChannelUrl(channel, payload = {}) {
  const text = buildShareText(payload)
  if (channel === 'whatsapp') {
    return `https://wa.me/?text=${encodeURIComponent(text)}`
  }
  return `https://t.me/share/url?url=${encodeURIComponent(payload.link || '')}&text=${encodeURIComponent([payload.title, payload.desc].filter(Boolean).join('\n'))}`
}

export async function shareByChannel(channel, payload = {}, platform = {}) {
  const nativeOk = await shareToNative(channel, payload, platform)
  if (nativeOk) return true
  const fallbackUrl = buildChannelUrl(channel, payload)
  openFallbackUrl(fallbackUrl)
  return false
}

export async function handleCopyLink(link = '') {
  const copied = await copyWithPlugin(link)
  if (copied) {
    showToast.success('Link copied')
    return true
  }
  showToast.warning('Copy failed')
  return false
}
